import { Avatar, Box, ButtonBase, Stack, useTheme } from "@mui/material";
import { ChevronRight } from "lucide-react";
import type { FC } from "react";

type Props = {
	icon?: string | React.ReactNode | null | undefined;
	iconText?: string;
	iconColor?: string;
	element: React.ReactNode;
	onClick: () => void;
};

export const CommonListItem: FC<Props> = ({
	icon,
	iconText,
	iconColor,
	element,
	onClick,
}) => {
	const theme = useTheme();

	let svgDataUri = "";
	if (typeof icon === "string") {
		svgDataUri = `data:image/svg+xml;utf8,${encodeURIComponent(icon ?? "")}`;
	}

	return (
		<Stack
			direction="row"
			alignItems="center"
			justifyContent="space-between"
			onClick={onClick}
			component={ButtonBase}
			sx={{ textAlign: "left" }}
		>
			<Stack gap={1.2} direction="row" alignItems="center" sx={{ minWidth: 0 }}>
				<Stack minWidth={80} alignItems="center" pl={1.6}>
					{svgDataUri ? (
						<Stack
							width={64}
							height={64}
							bgcolor={theme.palette.darkmodeText.white}
							borderRadius={9999}
							alignItems="center"
							justifyContent="center"
							sx={{ overflow: "hidden" }}
						>
							<Box
								component="img"
								sx={{
									width: 64,
									height: 64,
									display: "block",
								}}
								src={svgDataUri}
								alt={iconText}
							/>
						</Stack>
					) : icon ? (
						<Stack
							width={64}
							height={64}
							bgcolor={theme.palette.darkmodeText.white}
							alignItems="center"
							justifyContent="center"
							borderRadius={9999}
							sx={{ overflow: "hidden" }}
						>
							{icon}
						</Stack>
					) : (
						<Avatar
							sx={{
								width: 64,
								height: 64,
								fontSize: 18,
								fontWeight: 600,
								borderRadius: 9999,
								backgroundColor: iconColor ?? theme.palette.common.black,
								color: theme.palette.darkmodeText.white,
							}}
						>
							{iconText}
						</Avatar>
					)}
				</Stack>
				<Box sx={{ minWidth: 0 }}>{element}</Box>
			</Stack>
			<Stack p={0.8}>
				<ChevronRight size={16} color={theme.palette.primary.main} />
			</Stack>
		</Stack>
	);
};
